import _ from "lodash";
import TableReportHelper from "report/helper";
import { getTalhaoNomeDisplay, getTalhaoAreaDisplay } from "entity/Indicador/reports/talhaoDisplay";

export default async function perdMHeaderLocalizacaoReport(
    visita,
    indicador,
    apontamento,
    params,
    optLabelConformidade,
) {
    const h = new TableReportHelper(apontamento);
    const georeferencia = apontamento?.georeferencia;
    const IndicadorClass = indicador.constructor;

    if (!params) {
        return null;
    }

    const nomeAmostra = `${IndicadorClass.fullName} - ${IndicadorClass.abbrev}`;
    const status = IndicadorClass.getConformidadeStatus(apontamento.conformidade, params.meta);

    if (_.isEmpty(params)) {
        return h.panel(
            [
                h.row(h.title("Amostra"), h.text(nomeAmostra)),
                h.row(
                    h.title("ATENÇÃO: Não existem parâmetros configurados no cliente para este indicador.", {
                        colSpan: 2,
                    }),
                    await h.locationImageFieldHeaderOnly(georeferencia),
                ),
            ],
            { widths: [60, "*"] },
        );
    }

    const titleAr = [h.title("Talhão"), h.title("Área (ha)")];

    const valueAr = [h.text(getTalhaoNomeDisplay(apontamento)), h.text(getTalhaoAreaDisplay(apontamento))];

    if (apontamento.variedade) {
        titleAr.push(h.title("Variedade"));
        valueAr.push(h.textField("variedade.variedade"));
    }

    if (apontamento.corte) {
        titleAr.push(h.title("Corte"));
        valueAr.push(h.textField("corte"));
    }

    titleAr.push(h.title("TCH"), h.title("Frente"), h.title("Turno"), h.title("Operador"));

    valueAr.push(h.textField("tch"), h.textField("frente"), h.textField("turno"), h.textField("operador.operador"));

    const arr = titleAr.map((ta, i) => h.row(ta, valueAr[i]));

    const p1content = [
        h.row(h.title("Amostra"), h.text(nomeAmostra)),
        h.row(h.title("Tipo"), h.textField("tipo")),
        h.row(h.title(`Meta (%)`), h.text(params.meta)),
    ];

    const content = [];
    content.push([h.panel(p1content, { widths: [100, "*"] }), h.panel(arr, { widths: [100, "*"] })]);

    const panelMapa = [];
    panelMapa.push(
        h.panel([h.row(h.unbreakable(content), await h.locationImageFieldHeaderOnly(georeferencia))], {
            widths: ["*", 210],
        }),
    );

    const conditionalColetasTitle = [];
    const conditionalColetasValues = [];
    const conditionalColetasWidth = [];

    const tiposPerda = [
        { key: "toco", label: "Toco (g)" },
        { key: "ponteiro", label: "Ponteiro (g)" },
        { key: "canaInteira", label: "Cana Inteira (g)" },
        { key: "canaFixa", label: "Cana/Pedaço Fixo (g)" },
        { key: "estilhaco", label: "Estilhaço (g)" },
        { key: "tolete", label: "Tolete (g)" },
        { key: "pedaco", label: "Pedaço (g)" },
        { key: "lasca", label: "Lasca (g)" },
        { key: "toleteEstilhacado", label: "Tolete Estilhaçado (g)" },
    ];

    for (const tipo of tiposPerda) {
        if (params.hasOwnProperty(tipo.key) && params[tipo.key] === true) {
            conditionalColetasTitle.push(h.title(tipo.label));
            conditionalColetasValues.push(h.textField(tipo.key));
            conditionalColetasWidth.push("*");
        }
    }

    panelMapa.push(
        h.panel([h.row(h.title("COLETAS"))]),
        h.panel([h.row(conditionalColetasTitle), h.row(conditionalColetasValues)], { widths: conditionalColetasWidth }),
        h.panel(
            [
                h.row(
                    h.title("Total de Perdas (g)", { alignment: "right" }),
                    h.textField("totalPerdas"),
                    h.title(optLabelConformidade || "Perdas (%)"),
                    h.conformidadeField("conformidade", status, { alignment: "right" }),
                ),
            ],
            { widths: ["*", 80, 80, 80] },
        ),
    );

    return panelMapa;
}
